import { createFileRoute } from "@tanstack/react-router";
import { AdminCrawlerExclusionsTab } from "@/components/admin/pages/AdminCrawlerExclusionsTab";

export const Route = createFileRoute("/pulse-ops-x7k2/target-cities/crawler-exclusions")({
  component: AdminCrawlerExclusionsTab,
});
